import { makeAutoObservable } from 'mobx';
import apiHandler from '../handlers/ApiHandler';

class TrackingStore {
  promoCode = '';
  referralCode = '';
  referralName = '';
  referralType = '';

  constructor() {
    makeAutoObservable(this);
    this.loadFromSession();
  }

  // Call once on app mount to capture URL params
  captureFromUrl() {
    const params = new URLSearchParams(window.location.search);

    const promo = params.get('promo') || params.get('coupon') || params.get('code');
    if (promo) {
      this.setPromoCode(promo.toUpperCase());
    }

    const ref = params.get('ref') || params.get('referral');
    if (ref) {
      this.setReferralCode(ref.toUpperCase());
      this.trackReferralClick(ref.toUpperCase());
    }

    // Capture UTM attribution (first-party) so conversions can be traced to a
    // source/campaign. Persisted for the session; only set when present.
    const utm = {};
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'].forEach((k) => {
      const v = params.get(k);
      if (v) utm[k] = v;
    });
    if (Object.keys(utm).length) {
      sessionStorage.setItem('ep_utm', JSON.stringify(utm));
    }
  }

  setPromoCode(code) {
    this.promoCode = code;
    sessionStorage.setItem('ep_promo', code);
  }

  setReferralCode(code) {
    this.referralCode = code;
    sessionStorage.setItem('ep_ref', code);
  }

  clearPromoCode() {
    this.promoCode = '';
    sessionStorage.removeItem('ep_promo');
  }

  clearReferralCode() {
    this.referralCode = '';
    this.referralName = '';
    this.referralType = '';
    sessionStorage.removeItem('ep_ref');
  }

  loadFromSession() {
    this.promoCode = sessionStorage.getItem('ep_promo') || '';
    this.referralCode = sessionStorage.getItem('ep_ref') || '';
  }

  async trackReferralClick(code) {
    try {
      const result = await apiHandler.post(`/referrals/track/${code}`);
      if (result.valid) {
        this.referralName = result.referrerName;
        this.referralType = result.type;
      }
    } catch (e) {
      // Silently fail - don't block the user
    }
  }
}

const trackingStore = new TrackingStore();
export default trackingStore;
